import Vue from 'vue';
import store from './../../store';

const success = (resolve, response) => {
  store.dispatch('setDownloadProviderList', response.data);
  resolve(response);
};

const failed = (error, reject) => reject(error);


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/export-archive')
    .then((response) => {
      success(resolve, response);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/bill/archiveReport.js